export const POWER_BI_PARAMS = 'POWER_BI_PARAMS';
